import { atom } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { walletsStateAtom } from '@root/entities/wallet/atoms'

export const walletsExpandedAtom = atom<boolean>(false, 'walletsExpandedAtom')

export const showOnlyFavoritesAtom = atom<boolean>(
  false,
  'showOnlyFavoritesAtom',
)

export const walletsToShowStateAtom = atom((ctx) => {
  const onlyFavorites = ctx.spy(showOnlyFavoritesAtom)
  const state = ctx.spy(walletsStateAtom)
  return pipe(
    state,
    AsyncStateN.map((it) => {
      if (!onlyFavorites) {
        return it
      }
      return it.filter((it) => ctx.spy(it.favorite))
    }),
  )
}, 'walletsToShowStateAtom')
